import { CHAIN_IDS_TO_NAMES, DEFAULT_CHAIN_ID, SupportedChainId } from 'constants/chains'
import { NATIVE_CHAIN_ID } from 'constants/tokens'
import { CHAIN_ID_TO_BACKEND_NAME } from 'graphql/data/util'

export enum Chain {
  DUCX = 'DUCX',
  DUCX_TESTNET = 'DUCX_TESTNET',
  UnknownChain = 'UNKNOWN_CHAIN',
}

export const CHAIN_NAME_TO_CHAIN_ID: { [key in Chain]: SupportedChainId } = {
  [Chain.DUCX]: SupportedChainId.DUCX,
  [Chain.DUCX_TESTNET]: SupportedChainId.DUCX_TESTNET,
  [Chain.UnknownChain]: SupportedChainId.DUCX_TESTNET,
}

const URL_CHAIN_PARAM_TO_BACKEND: { [key: string]: Chain } = {
  [CHAIN_IDS_TO_NAMES[SupportedChainId.DUCX]]: Chain.DUCX,
  [CHAIN_IDS_TO_NAMES[SupportedChainId.DUCX_TESTNET]]: Chain.DUCX_TESTNET,
}

export function chainIdToBackendName(chainId: number | undefined) {
  return chainId && CHAIN_ID_TO_BACKEND_NAME[chainId]
    ? CHAIN_ID_TO_BACKEND_NAME[chainId]
    : CHAIN_ID_TO_BACKEND_NAME[DEFAULT_CHAIN_ID]
}

export function validateUrlChainParam(chainName: string | undefined) {
  return chainName && URL_CHAIN_PARAM_TO_BACKEND[chainName] ? URL_CHAIN_PARAM_TO_BACKEND[chainName] : Chain.DUCX
}

export function getTokenDetailsURL({
  address,
  chain,
  inputAddress,
}: {
  address?: string | null
  chain: Chain
  inputAddress?: string | null
}) {
  const chainName = chain.toLowerCase()
  const tokenAddress = address ?? NATIVE_CHAIN_ID
  const inputAddressSuffix = inputAddress ? `?inputCurrency=${inputAddress}` : ''
  return `/tokens/${chainName}/${tokenAddress}${inputAddressSuffix}`
}
